/**
 * What the app needs from whatever it runs inside.
 */
import type { ApiClient } from '@/api/client'
import type { Tokens } from '@/api/types'

export interface Coordinates {
  lat: number
  lon: number
}

export interface BackButton {
  show(onClick: () => void): void
  hide(): void
}

export interface Platform {
  kind: 'telegram' | 'browser'
  /** Telegram: ready(), expand(), theme variables. Browser: nothing to do. */
  init(): Promise<void>
  /** Telegram signs the user in silently; the browser returns null and the Login screen takes over. */
  authenticate(api: ApiClient): Promise<Tokens | null>
  getLocation(): Promise<Coordinates>
  /**
   * Состояние разрешения, не спрашивая его. Везде, где ответа нет — старый
   * Safari, старый клиент Telegram, — это 'unknown', и интерфейс молчит
   * вместо того, чтобы угадывать.
   */
  readLocationPermission(): Promise<LocationPermission>
  /**
   * Open wherever the user manages the location permission for this app.
   * Nothing on the web can revoke a permission from code, so this returns
   * false where there is no such screen and the interface says so in words.
   */
  openLocationSettings(): boolean
  /** Payment pages and ad links must leave the WebView. */
  openExternal(url: string): void
  /**
   * Telegram's own payment sheet for a Stars invoice link. Resolves with the
   * status Telegram reports; the browser has no such sheet and says 'failed'.
   */
  openInvoice(url: string): Promise<InvoiceStatus>
  backButton: BackButton
  theme(): 'light' | 'dark'
  haptic(type: 'success' | 'error' | 'light'): void
}

export type InvoiceStatus = 'paid' | 'cancelled' | 'failed' | 'pending'

/** Что известно о разрешении на геолокацию, до того как его спросили. */
export type LocationPermission = 'granted' | 'denied' | 'prompt' | 'unknown'

export class LocationDenied extends Error {
  constructor(message = 'Location permission denied') {
    super(message)
    this.name = 'LocationDenied'
  }
}

export class LocationUnavailable extends Error {
  constructor(message = 'Location is not available') {
    super(message)
    this.name = 'LocationUnavailable'
  }
}
